export default __webpack_public_path__ + "static/100--stacked-bar-d50300aea0f85bdbd511a85a9202c48c.png";